import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import useSelectedStore from "../../hooks/useSelectedStore";
import useLogoFevIcon from "../../hooks/useLogoFevIcon";
const PageNotFound = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { fevicon } = useLogoFevIcon()
  const { selectedStore } = useSelectedStore();
  useEffect(() => {

    // console.log('fevIconUrl', fevIconUrl)
    const link: HTMLLinkElement =
      document.querySelector("link[rel='icon']") ||
      document.createElement("link");
    link.type = "image/x-icon";
    link.rel = "icon";
    // console.log("fevIconUrl",fevIconUrl)
    link.href = fevicon;
    document.head.appendChild(link);
  }, [selectedStore, fevicon]);

  return (
    <div className="pageNotFOund">
      <div className="iconBlock">
        <i className="fa fa-question-circle" aria-hidden="true"></i>
      </div>
      <h2 className="mt-4 mb-4">{t("NotFound.line1")}</h2>
      <p>{t("NotFound.line2")}</p>
      <div
        onClick={() => navigate("/")}
        className="btn btnBlue NotFound text-white bgBlue font-medium rounded-[7px] text-center inline-flex items-center justify-center cursor-pointer w-50 "
      >
        {t("Home.goToMenu")}
      </div>
    </div>
  );
};

export default PageNotFound;
